import { useEffect } from "react";
import { saveVisite } from "../../../services/visitesServices";

export const useVisitTracker = () => {
  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const lastVisitDate = localStorage.getItem("lastVisitDate");

    if (lastVisitDate === today) return;

    saveVisite({})
      .then(() => {
        localStorage.setItem("lastVisitDate", today);
      })
      .catch((error) => {
        console.error("Erreur lors de l'enregistrement de la visite:", error);
      });
  }, []);
};